import { GetterTree } from 'vuex';

import { decode } from '@/utils/custom-enc-dec';
import { snakeToCamel } from '@/utils';

import {
  AuthStateI,
  UserI,
  ProjectI,
  PermissionI,
} from './state';
import { RootStateI } from '../state';

export const getters: GetterTree<AuthStateI, RootStateI> = {
  isAuthenticated: (state) => {
    const user = localStorage.getItem('user');
    const projects = localStorage.getItem('projects');
    const project = localStorage.getItem('project');
    // const perms = localStorage.getItem('permissions');
    const token = localStorage.getItem('token');
    return !!user && !!projects && !!project && !!token;
  },
  user: (state) => {
    const encodedUser = localStorage.getItem('user');
    if (!encodedUser) return state.user;
    const { value } = decode(encodedUser);
    const user = typeof value === 'string' ? JSON.parse(value) : value;
    return snakeToCamel(user) as UserI;
  },
  projects: (state) => {
    const encodedProjects = localStorage.getItem('projects');
    if (!encodedProjects) return state.projects;
    return decode(encodedProjects).value;
  },
  project: (state) => {
    const encodedProject = localStorage.getItem('project');
    if (!encodedProject) return state.googleProject;
    return decode(encodedProject).value as ProjectI;
  },
  permissions: (state) => {
    const encodedPermissions = localStorage.getItem('permissions');
    if (!encodedPermissions) return state.permissions;
    return decode(encodedPermissions).value as PermissionI[];
  },
};
